import { Accordion } from '../../../../../components/general/accordion';
import CircleNotificationsIcon from '@mui/icons-material/CircleNotifications';
import { PqrNotificationAreasHistoryProps } from './props';
import { usePqrNotificationAlertHistory } from './hook';
import { Table } from '../../../../../components/general/table';

export const PqrNotificationAreasHistory = (
    props: PqrNotificationAreasHistoryProps
) => {
    const { columns, rows, loading, page, pageSize, paginator, total } =
        usePqrNotificationAlertHistory(props);

    return (
        <Accordion
            title="HISTÓRICO NOTIFICACIÓN AREAS"
            icon={<CircleNotificationsIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={false}
            mt={0}
        >
            <Table
                columns={columns}
                rows={rows}
                rowCount={total}
                loading={loading}
                paginationModel={{
                    page,
                    pageSize,
                }}
                onPaginationModelChange={paginator}
                pageSizeOptions={[2, 10, 20, 50]}
                disableRowSelectionOnClick
            />
        </Accordion>
    );
};
